export { default as ContentfulContentRow } from './contentfulContentRow'



// WEBPACK FOOTER //
// ./src/modules/contentful/contentRow/index.js